// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FeatureType, FeatureTypeArr } from "../schema";
import { serialize_FeatureType_internal, deserialize_FeatureType_internal } from "./FeatureType";

export function serialize_FeatureTypeArr_internal(value: FeatureTypeArr): unknown {
  return ((value: { items: FeatureType[] }): unknown => {
    return {
      items: ((value: FeatureType[]): unknown => {
        return value.map((value: FeatureType): unknown => {
          return serialize_FeatureType_internal(value);
        });
      })(value["items"]),
    };
  })(value);
}
export function serialize_FeatureTypeArr(obj: FeatureTypeArr): string {
  return renderJsonWithNumbersAsBigint(serialize_FeatureTypeArr_internal(obj));
}
export function deserialize_FeatureTypeArr_internal(value: unknown): ParserResult<FeatureTypeArr> {
  return ((
    value: unknown,
  ): ParserResult<{
    items: FeatureType[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/FeatureTypeArr]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/FeatureTypeArr]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "items")) {
      return { success: false, reason: `[#/components/schemas/FeatureTypeArr/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
    }
    const parsed_items = ((): ParserResult<FeatureType[]> => {
      return ((value: unknown): ParserResult<FeatureType[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/FeatureTypeArr/items]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<FeatureType> => {
          return deserialize_FeatureType_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/FeatureTypeArr/items]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["items"]);
    })();
    if (!parsed_items.success) {
      return { success: false, reason: parsed_items.reason };
    }
    return { success: true, value: { items: parsed_items.value } };
  })(value);
}
export function deserialize_FeatureTypeArr(str: string): ParserResult<FeatureTypeArr> {
  return deserialize_FeatureTypeArr_internal(parseJsonWithNumbersAsBigint(str));
}
